import { CustomerCompanyMessage } from '../../../../../types/CustomerCompanyMessage';
import { GenericError } from '../../../../common/Error/GenericError';
import { useRole } from '../../../../common/hooks/useRole';
import { LoadingIndicator } from '../../../../common/LoadingIndicator/LoadingIndicator';
import { Box } from '../../../../common/ui/Box';
import { CustomerAdminSettings } from '../../../CustomerAdminSettings';
import { ApprovalSettings } from '../ApprovalSettings';
import { useCustomerSettings } from '../useCustomerSettings';

interface CustomerSettingsTabProps {
    customer: CustomerCompanyMessage;
}

export const CustomerSettingsTab = ({ customer }: CustomerSettingsTabProps) => {
    const role = useRole();
    const customerId = customer.id;
    const customerSettingsQuery = useCustomerSettings(customerId);

    if (customerSettingsQuery.isPending) {
        return <LoadingIndicator />;
    }

    if (customerSettingsQuery.isError) {
        return <GenericError />;
    }

    const settings = customerSettingsQuery.data;

    return (
        <Box display="flex" flexDirection="column" gap={40}>
            <ApprovalSettings customerSettings={settings} customerId={customerId} />

            {role.isSuperAdmin() ? (
                <CustomerAdminSettings companyDetails={customer} customerSettings={settings} />
            ) : null}
        </Box>
    );
};
